<template>
  <div id="timeLimitDetail">
    <div class="container-inner">
      <img class="goBack" @click="goBack" src="../../../../assets/images/activity/goBack.png" alt="">
      <div class="container">
        <div class="headerTitle" :style="{ background: getBgColor(storeInfo.storeType) }">
          <div class="shop-info">
            <div class="shop-logo">
              <img :src="storeInfo?.logoUrl" alt="">
            </div>
          </div>
          <div class="shop-details">
            <div class="shop-name">
              <span class="shop-img">
                <img v-if="storeInfo?.storeType == 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                <img v-if="storeInfo?.storeType == 'S'" src="@/assets/images/pt-zy.png" alt="">
              </span>
              <span class="name">{{ storeInfo?.storeName }}</span>
            </div>
            <div class="shop-desc" ref="shopDescRef" :class="isOpen ? 'desc-open-close' : ''">
              {{ storeInfo?.detail }}
              <div class="open-close-box" v-if="isShowOpen">
                <div class="open-btn common-btn" v-show="!isOpen" @click="handleChangeOpenClose">展开 <el-icon class="el-icon-caret-bottom"></el-icon> </div>
                <div class="close-btn common-btn" v-show="isOpen" @click="handleChangeOpenClose">收起 <el-icon class="el-icon-caret-top"></el-icon> </div>
              </div>
            </div>
            <div class="shop-tags">
              <div class="tag-item" v-for="item of storeInfo.storeTagList" :key="item.tagId">
                <p class="title">{{ item.tagName }}</p>丨
                <p class="content">{{ item.tagDescription }}</p>
              </div>
            </div>
          </div>
          <div class="shop-actions">
            <span class="action-btn" @click="handleStorePhone(storeInfo?.note)">
              <img src="../../../../assets/images/activity/phone.png" alt="">
              联系商家
            </span>
            <span class="action-btn" @click="handleStoreDetail(storeInfo?.storeId)">进店逛逛<i class="el-icon-arrow-right"></i></span>
          </div>
        </div>
        <!-- 商品主体内容 -->
        <div class="product-main">
          <div class="main-left-scroll">
            <!-- 左侧区域 -->
            <div class="main_left">
              <!-- 轮播图区域 -->
              <div class="leftWrap">
                <wheelSeed :img-url-list="goodDetail.newImgs" @removeSkuImg="handleRemoveSkuImg" :skuImg='currentSkuImg' />
                <!-- <div class="img-swipe">
                  <el-carousel trigger="click">
                    <el-carousel-item v-for="(imgObj, index) in goodDetail?.newImgs" :key="imgObj.imgId">
                      <video
                        v-show="imgObj.type === 'V'"
                        :src="imgObj.img"
                        controls
                        autoplay
                        muted
                        @play="handleVideoPlay(index)"
                      ></video>
                      <img v-show="imgObj.type === 'P'" :src="imgObj.img" alt="">
                    </el-carousel-item>
                  </el-carousel>
                </div> -->
                <!-- 缩略图 -->
                <!-- <div class="img-thumbnail">
                  <div class="thumbnail-left"> <el-icon class="el-icon-arrow-left"></el-icon> </div>
                  <div class="thumbnail-list">
                    <div class="thumbnail-blank-space">
                      <div class="thumbnail-item" v-for="item of 10" :key="item"></div>
                    </div>
                  </div>
                  <div class="thumbnail-right"> <el-icon class="el-icon-arrow-right"></el-icon> </div>
                </div> -->
              </div>
              <div class="detailsBox">
                <h1>图文详情</h1>
                <div class="details">
                  <div v-html="goodDetail.note" class="note-text"></div>
                  <p class="price-text" v-if="goodDetail.priceDescription">价格说明:</p>
                  <p v-if="goodDetail.priceDescription" v-html="goodDetail.priceDescription"></p>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧区域 -->
          <div class="main_right">
            <div class="title">{{ goodDetail.commodityName }}</div>
            <div class="tags">
              <span v-for="(itemTag, indexTag) in goodDetail.tags" :key="indexTag">
                {{ itemTag.tagName }}
                <span v-show="Number(goodDetail.tags.length - 1) !== Number(indexTag)">丨</span>
              </span>
            </div>
            <div class="Info">
              <div class="price-box">
                <!-- 余额 -->
                <div class="price-balance" v-if="payTypeInfo?.payType === 1">
                  <!-- 零售价 -->
                  <span class="balance-retailing">
                    <span style="font-size: 12px">¥</span>
                    <span>{{ skuInfo.retailPrice }}</span>
                  </span>
                  <!-- 原价 -->
                  <span class="balance-original">
                    <span>¥</span>
                    <span>{{ skuInfo.skuPrice }}</span>
                  </span>
                </div>
                <!-- 提货值 -->
                <div class="price-pick" v-else-if="payTypeInfo?.payType === 2">
                  <!-- 零售价 -->
                  <span class="pick-retailing">
                    <span>{{ skuInfo.retailPrice }}</span>
                    <span>提货值</span>
                  </span>
                  <!-- 原价 -->
                  <span class="pick-original">
                    <span>{{ skuInfo.skuPrice }}</span>
                    <span>提货值</span>
                  </span>
                </div>
              </div>
              <div class="inventory">
                <span>库存：{{ totalReserve }}</span>
                <span>已售：{{ totalSalesNumber }}</span>
              </div>
            </div>
            <div v-if="JSON.stringify(addressObj)!='{}'" class="addressInfo">
              <div class="btwInfo">
                <div>
                  送至
                  <span>{{ addressObj.addressName }}</span>
                </div>
                <i class="el-icon-arrow-right" @click="addList"></i>
              </div>
            </div>
            <div class="addressInfo" v-else>
              <div class="btwInfo">
                <div>
                  送至
                </div>
                <div class="addAddress" @click="goAddress">暂无地址<i class="el-icon-plus"></i></div>
              </div>
            </div>
            <div class="addressInfo">
              <div class="btwInfo">
                <div>
                  运费
                  <span>{{ goodDetail.distributionType === 1 ? '不包邮' : '包邮' }}</span>
                </div>
              </div>
            </div>
            <div class="addressInfo">
              <div class="btwInfo">
                <div>
                  服务
                  <span>
                    {{ paramNamesTextServe }}
                    <el-dropdown 
                      trigger="click" 
                      @visible-change="handleServeDropdownChange"
                      placement="bottom"
                    >
                      <span class="el-dropdown-link" style="margin-left: 0;cursor: pointer;">
                        <i class="el-icon-arrow-down el-icon--right dropdown-arrow" :class="{ 'is-reverse': isServeDropdownVisible }"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown" popper-class="custom-parameter-dropdown">
                        <div class="serve">
                          <h1>服务说明</h1>
                          <div class="item" v-for="(param, index) in serveParams" :key="index">
                            <div class="label">
                              <div class="left">
                                <img class="img" src="@/assets/images/activity/check.png" alt="">
                                <div class="serve_text">{{ param.serviceName }}</div>
                              </div>
                              <img class="rightImg" src="@/assets/images/activity/right.png" v-show="param.serverDetails" alt="" @click="toDetail(param)">
                            </div>
                            <div class="value">{{ param.serviceDesc }}</div>
                          </div>
                          <div v-if="parsedProductParams.length === 0" class="no-params">
                            暂无服务信息
                          </div>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                </div>
              </div>
            </div>
            <div class="addressInfo">
              <div class="btwInfo">
                <div class="param-info">
                  参数
                  <span style="display: flex; align-item: center">
                    <div class="param-names-text">
                      {{ paramNamesText }}
                    </div>
                    <el-dropdown 
                      trigger="click" 
                      @visible-change="handleParamDropdownChange"
                      placement="bottom"
                    >
                      <span class="el-dropdown-link" style="margin-left: 0;cursor: pointer;">
                        <i class="el-icon-arrow-down el-icon--right dropdown-arrow" :class="{ 'is-reverse': isParamDropdownVisible }"></i>
                      </span>
                      <el-dropdown-menu 
                        slot="dropdown" 
                        popper-class="custom-parameter-dropdown"
                      >
                        <div class="parameter">
                          <h1>参数信息</h1>
                          <div class="param-list">
                            <div class="item" v-for="(param, index) in parsedProductParams" :key="index">
                              <div class="label">{{ param.paramName }}</div>
                              <div class="value">{{ param.paramValue }}</div>
                            </div>
                            <div v-if="parsedProductParams.length === 0" class="no-params">
                              暂无参数信息
                            </div>
                          </div>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                </div>
              </div>
            </div>
            <div class="skus">
              <p class="title">规格</p>
              <div class="skuItem-scroll">
                <div class="skuItem">
                  <div
                    class="item"
                    v-show="Number(sku.display) === 1"
                    v-for="(sku, index) in goodDetail.skus"
                    :key="sku.skuId"
                    :class="{ active: selectedSkuIndex === index }"
                    @click="selectSku(sku, index)"
                  >
                    {{ sku.skuName.replace(/\|/g, " ") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="skusNum">
              <p class="title" v-if="Number(currentSku.limitNum) !== -1">
                数量
                <span v-if="Number(currentSku.limitNum) !== -1">（最多可购买{{ totalReserve ? currentSku.limitNum : 0 }}件）</span>
              </p>
              <div class="btnNum">
                <!-- 限购 -->
                <el-input-number
                  v-if="Number(currentSku.limitNum) !== -1"
                  v-model="num"
                  :min="1"
                  :max="totalReserve ? currentSku.limitNum : 0"
                  @keydown.native="handleKeyDown"
                ></el-input-number>
                <!-- 不限购 -->
                <el-input-number
                  v-if="Number(currentSku.limitNum) === -1"
                  v-model="num"
                  :min="1"
                  @keydown.native="handleKeyDown"
                ></el-input-number>
                <div class="btnBuy" v-if="totalReserve" @click="handleBuy">立即购买</div>
                <div class="btnFinish" v-if="!totalReserve" @click="$message('商品已售罄')">已售罄</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <addressPop ref="addressDia" :is-detail="true" @complate="complateAddress" />
    <addListDialog ref="addListDia" :choose-add-id="addressObj.addressId" @changAddId="changeAddId" />
    <Cellphone :phone="cellStore" ref="cellphoneRef" />
  </div>
</template>
<script>
/*global http protocol BaseApi Toast util*/
import { mapMutations, mapState } from 'vuex'
import wheelSeed from '@/components/base/wheelSeed/wheelSeed.vue'
import addListDialog from '@/components/address/addListDialog.vue'
import addressPop from '@/components/address/addressPop.vue'
import Cellphone from '@/views/equityMall/pt/components/cellStore.vue'
export default {
  components: {
    wheelSeed,
    addListDialog,
    addressPop,
    Cellphone
  },
  data() {
    return {
      cellStore: null,
      currentSkuImg: '',
      isShowOpen: false, // 是否展示 展开收起按钮
      isOpen: false, // 是否展开
      isServeDropdownVisible: false, // 服务下拉菜单展开状态
      isParamDropdownVisible: false, // 参数下拉菜单展开状态
      addressObj: {},
      goodDetail: {},
      storeInfo: {}, // 店铺信息
      selectedSkuIndex: 0, // 当前选中的 SKU 索引
      num: 1, // 购买数量
      productDetail: {
        commodityName: '',
        subtitle: '',
        discountPrice: 0,
        originalPrice: 0,
        stock: 0,
        specs: [],
        sizes: [],
        detailImages: []
      },
      productImages: [],
      currentImageIndex: 0,
      selectedSpec: 0,
      selectedSize: 0,
      quantity: 1,
      storeId: null,
      commodityId: null,
      activityId: null,
      payTypeInfo: null,
      commoditySkuId: null,
      currentSku: {
        limitNum: null
      },
      skuInfo: {}
    }
  },
  computed: {
    ...mapState('pt', ['userSelect']),
    currentImage() {
      return this.productImages[this.currentImageIndex] || ''
    },
    // 计算总销售数量
    totalSalesNumber() {
      if (!this.goodDetail.skus || this.goodDetail.skus.length === 0) {
        return 0
      }
      return this.goodDetail.skus.reduce((total, sku) => {
        if (Number(sku.display) === 0) {
          return total
        }
        const initSales = sku.initSalesNumber || 0
        const sales = sku.salesNumber || 0
        return total + initSales + sales
      }, 0)
    },
    // 计算总库存数量
    totalReserve() {
      if (!this.goodDetail.skus || this.goodDetail.skus.length === 0) {
        return 0
      }
      const res = this.goodDetail.skus.reduce((total, sku) => {
        if (Number(sku.display) === 0) {
          return total
        }
        const quantity = sku.skuQuantity || 0
        return total + quantity
      }, 0)
      return res
    },
    // 解析服务参数数据
    serveParams() {
      try {
        if (!this.goodDetail.commodityServices) {
          return []
        }
        if (typeof this.goodDetail.commodityServices === 'string') {
          return JSON.parse(this.goodDetail.commodityServices)
        }
        return this.goodDetail.commodityServices
      } catch (error) {
        console.error('解析商品参数失败:', error)
        return []
      }
    },
    // 提取所有服务名称用于展示
    paramNamesTextServe() {
      if (this.serveParams.length === 0) {
        return '暂无服务'
      }
      return this.serveParams.map(param => param.serviceName).join(' ')
    },
    // 提取所有参数名称用于展示
    paramNamesText() {
      if (this.parsedProductParams.length === 0) {
        return '暂无参数'
      }
      return this.parsedProductParams.map(param => param.paramName).join(' ')
    },
    // 解析商品参数数据
    parsedProductParams() {
      try {
        if (!this.goodDetail.productParams) {
          return []
        }
        // 如果是字符串,解析为数组
        if (typeof this.goodDetail.productParams === 'string') {
          return JSON.parse(this.goodDetail.productParams)
        }
        // 如果已经是数组,直接返回
        return this.goodDetail.productParams
      } catch (error) {
        console.error('解析商品参数失败:', error)
        return []
      }
    }
  },
  created() {
    const { storeId, commodityId } = this.$route.query
    this.storeId = storeId
    this.commodityId = commodityId
    this.getDetail()
    const defalutAdd = sessionStorage.getItem('defaultAddress') // 读取sessionStorage中的地址
    if (defalutAdd) { // 有地址则直接使用
      this.addressObj = JSON.parse(defalutAdd)
    } else { // 无地址则从接口请求
      this.queryFirmAddress()
    }
  },
  methods: {
    ...mapMutations('pt', ['setSureOrderInfo', 'setUserSelect', 'removeUserSelect', 'setServiceDetail']),

    // 处理服务下拉菜单展开/收起
    handleServeDropdownChange(visible) {
      this.isServeDropdownVisible = visible
    },
    // 处理参数下拉菜单展开/收起
    handleParamDropdownChange(visible) {
      this.isParamDropdownVisible = visible
    },

    handleKeyDown(event) {
      // 阻止小数点（包括.和小键盘的.）
      if (event.key === '.' || event.keyCode === 190 || event.keyCode === 110) {
        event.preventDefault()
        return false
      }
      // 可选：阻止其他非数字字符（但允许控制键）
      const allowedKeys = [
        'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
      ]
      // 如果不是允许的键，则阻止
      if (!allowedKeys.includes(event.key) &&
          !event.ctrlKey && !event.metaKey &&
          (event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault()
        return false
      }
    },

    handleRemoveSkuImg() {
      this.currentSkuImg = ''
    },

    // 切换展开状态
    handleChangeOpenClose() {
      this.isOpen = !this.isOpen
    },

    // 服务详情页面
    toDetail(param) {
      this.setServiceDetail(param)
      this.$router.push({
        name: 'serviceDetail'
      })
    },

    // 联系商家
    handleStorePhone(phone) {
      this.cellStore = phone
      this.$refs.cellphoneRef.showDialog()
      // this.$alert(phone, '联系商家', {
      //   confirmButtonText: '确定',
      // });
      // this.$confirm('确认放弃支付?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   confirmButtonClass: 'giveUpConfirmButton',
      //   cancelButtonClass: 'giveUpcancelButton',
      //   type: 'warning'
      // })
    },
    // 跳转店铺详情页
    handleStoreDetail(storeId) {
      this.$router.push({
        name: 'ptOrdinaryStoreDetail',
        query: {
          storeId: storeId
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    complateAddress() {
      this.queryFirmAddress()
    },
    addList() {
      const params = {
        id: this.addressObj.addressId
      }
      this.$refs.addListDia.openDialog(params)
    },
    goAddress() {
      const params = {
        isAdd: 'add'
      }
      this.$refs.addressDia.openDialog(params)
    },
    changeAddId(address) {
      this.addressObj = address
    },
    // 获取收货地址
    queryFirmAddress() {
      const that = this
      BaseApi.getUserAddress({}).then((response) => {
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            for (const item of value) {
              if (item.defaultFlag) {
                this.addressObj = item
                sessionStorage.setItem('defaultAddress', JSON.stringify(item)) // 保存默认地址
              }
            }
          }
        } else {
          this.$message(message)
        }
      })
    },
    getBgColor(val) {
      switch (val) {
        case 'S':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FEECEB 100%)'
        case 'U':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FDF4DA 100%)'
        default:
          return '#fff'
      }
    },
    // 获取商品详情
    getDetail() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryCommodity))
      apiObj.param = {
        page: 0,
        size: 99999,
        commodityId: this.commodityId,
        sort: [{
          direction: 'DESC',
          property: 'sortId'
        }]
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.getStoreInfo(value.content[0].storeId) // 查询店铺信息
            // 对图片进行排序: isMain为'1'的排在最前面,其他按原顺序
            const sortedImgs = value.content[0].imgs.sort((a, b) => {
              if (a.isMain === '1' && b.isMain !== '1') return -1
              if (a.isMain !== '1' && b.isMain === '1') return 1
              return 0
            })
            value.content[0].newImgs = sortedImgs // 保存排序后的图片(轮播图展示)
            this.goodDetail = value.content[0] // 保存商品列表
            this.payTypeInfo = this.goodDetail.pays[0] // 保存支付方式
            if (this.userSelect) { // 有用户选择的商品信息, 回显用户先择的内容
              const { skuInfo, buyNum, selectedSkuIndex } = this.userSelect
              this.skuInfo = skuInfo
              this.num = buyNum
              this.selectedSkuIndex = selectedSkuIndex // 回显用户选择的规格
              this.getLimitBuy(this.skuInfo) // 查询当前回显规格的限购数量
              this.removeUserSelect(null) // 清空用户选择
            } else {
              this.skuInfo = this.minRetailPrice(this.goodDetail.skus, 'retailPrice') // 保存最小规格
              this.getLimitBuy(this.skuInfo) // 查询当前最小价格规格的限购数量
              this.selectedSkuIndex = this.skuInfo.minIndex // 保存当前最小价格规格的sku索引
            }
            this.currentSkuImg = this.skuInfo.skuImg
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 筛选skus对象数组中对象的property属性是最小值的对象
    minRetailPrice(skus, property) {
      let min = ''
      let minIndex = ''
      if (!skus) {
        return {
          minIndex: '' // 为空串, 没有最低价格
        }
      }
      for (let i = 0; i < skus.length; i++) {
        const el = skus[i]
        if (el.display === '1' && (min === '' || el[property] < min)) {
          min = el[property]
          minIndex = i
        }
      }
      if (minIndex === '') {
        return {
          minIndex: '' // 为空串, 没有最低价格
        }
      } else {
        const obj = {
          minIndex, // 最低规格价格在规格数组中的位置
          ...skus[minIndex] // 最低价格规格的信息
        }
        return obj
      }
    },
    // 查询店铺信息
    getStoreInfo(storeId) {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryStore))
      apiObj.param = {
        page: 0,
        size: 99999,
        storeId: storeId
      }
      http.postFrontMall(apiObj).then((res) => {
        const { code, value, message } = res.data
        if (Number(code) === 0) {
          this.storeInfo = value.content[0]
          this.$nextTick(() => {
            const targetElement = this.$refs.shopDescRef
            this.isShowOpen = targetElement.clientHeight < targetElement.scrollHeight
          })
        } else {
          this.$message(message)
        }
      })
    },
    getMyAsset() {
      // const apiObj = JSON.parse(JSON.stringify(protocol.param_findMyAssetMarket))
      // http.postFrontMall(apiObj).then((response) => {
      //   const { code, message, value } = response.data
      //   if (code === 0 || code === '0') {
      //     if (value) {
      //       const sureOrderInfo = {
      //         skuInfo: this.skuInfo,
      //         buyNum: this.num, // 当前规格购买数量
      //         totalRetailPrice: util.floatMul(this.skuInfo.retailPrice, this.num),
      //         ...this.goodDetail,
      //         addressObj: this.addressObj
      //       }
      //       this.setSureOrderInfo(sureOrderInfo)
      //       this.$router.push({
      //         name: 'ptSureOrder',
      //       })
      //       // 保存当前用于选择的数据
      //     }
      //   } else {
      //     this.$message(message)
      //   }
      // })
      // 提供给订单页面使用
      const sureOrderInfo = {
        skuInfo: this.skuInfo,
        buyNum: this.num,
        totalRetailPrice: util.floatMul(this.skuInfo.retailPrice, this.num),
        retailPrice: this.skuInfo.retailPrice,
        ...this.goodDetail,
        addressObj: this.addressObj
      }
      this.setSureOrderInfo(sureOrderInfo)
      this.$router.push({
        name: 'ptSureOrder'
      })
      // 保存用户选择的数据
      const userSelect = {
        skuInfo: this.skuInfo, // 当前skuInfo
        buyNum: this.num, // 购买数量
        selectedSkuIndex: this.selectedSkuIndex // 所选sku的索引
      }
      // 保存用户所选信息
      this.setUserSelect(userSelect)
    },
    // 立即购买
    handleBuy() {
      if (Number(this.currentSku.limitNum) === 0) {
        this.$message('已达最大购买数量')
        return
      }

      // 跳转到订单确认页面或执行购买逻辑
      if (JSON.stringify(this.addressObj) === '{}') {
        this.$message('你还没有收货地址哦，赶快设置一个吧')
        return
      }
      this.getMyAsset()
    },
    // 查询限购数量
    getLimitBuy(sku) {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryLimitNum))
      apiObj.param = {
        skuId: sku.skuId,
        commodityId: sku.commodityId
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value || Number(value) === 0) {
            this.currentSku.limitNum = value
            console.log(this.currentSku.limitNum)
          }
          return true
        } else {
          Toast(message)
          return false
        }
      })
    },
    // 选择 SKU
    selectSku(sku, index) {
      this.currentSkuImg = sku.skuImg
      this.skuInfo = sku // 保存当前点击的规格规格信息
      this.commoditySkuId = sku.skuId
      this.selectedSkuIndex = index
      this.getLimitBuy(sku)
    }
  }
}
</script>
<style lang="scss" scoped>
#timeLimitDetail {
  background: #FFFFFF;
  min-height: calc(100vh - 40px);
  // padding-bottom: 50px;
  color: #333;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  .container-inner {
    min-height: calc(100vh - 40px);
  }
  .goBack {
    position: absolute;
    top: 30px;
    left: 50px;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0 0;
    .headerTitle {
      width: 100%;
      // background: linear-gradient(0deg, #fff, #FEECEB 100%);
      display: flex;
      gap: 10px;
      padding: 18px 20px;
      box-sizing: border-box;
      // 左侧店铺信息
      .shop-info {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        .shop-logo {
          width: 68px;
          height: 68px;
          background: #FFFFFF;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .shop-details {
        flex: 1;
        .shop-name {
          display: flex;
          align-items: center;
          gap: 10px;
          .shop-img {
            height: 16px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .name {
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }
        }
        .shop-desc {
          margin-top: 3px;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          height: 20px;
          width: 300px;
          overflow: hidden;
          position: relative;
          &.desc-open-close {
            height: auto;
            padding-bottom: 20px;
          }
          .open-close-box {
            position: absolute;
            bottom: 0;
            right: 0;
            .common-btn {
              width: 60px;
              height: 20px;
              background: #cccccc;
              text-align: center;
              line-height: 20px;
              cursor: pointer;
              border-radius: 3px;
              user-select: none;
              color: #999999;
              font-size: 12px;
            }
            .open-btn {

            }
            .close-btn {

            }
          }
        }
        .shop-tags {
          margin-top: 2px;
          display: flex;
          align-items: center;
          gap: 20px;
          .tag-item {
            display: flex;
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
        }
      }
      // 右侧操作按钮
      .shop-actions {
        width: 200px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 16px;
        .action-btn {
          font-size: 14px;
          color: #999999;
          cursor: pointer;
          transition: color 0.3s;
          display: flex;
          align-items: center;
          img {
            margin: 1px 2px 0 0;
          }
          // &:hover {
          //   color: #FF6B4A;
          // }
        }
      }
    }
    // 商品主体内容
    .product-main {
      display: flex;
      gap: 40px;
      background: #FFFFFF;
      height: calc(100vh - 80px - 124px);
      .main_left {
        height: calc(100vh - 80px - 124px);
        overflow-y: auto;
        overflow-x: hidden;
        width: 560px;
        /* 隐藏滚动条 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        .leftWrap {
          width: 100%;
          position: relative;
          .img-swipe {
            width: 100%;
            position: relative;
            .img-swipe {
              width: 100%;
              height: 558px;
              background: #f4f4f4;
              /deep/.el-carousel {
                width: 100%;
                height: 100%;
                .el-carousel__container {
                  width: 100%;
                  height: 100%;
                  .el-carousel__item {
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                    }
                    video {
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                    }
                  }
                }
                .el-carousel__indicators {
                  display: none;
                }
                .el-carousel__arrow {
                  display: none;
                }
              }
            }
            .img-thumbnail {
              width: 560px;
              margin: 30px 0;
              display: flex;
              .thumbnail-left {
                flex: 1;
                // background: #f4f4f4;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 20px;
              }
              .thumbnail-right {
                flex: 1;
                // background: #f4f4f4;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 20px;
              }
              .thumbnail-list {
                height: 80px;
                width: 464px;
                overflow-x: scroll;
                overflow-y: hidden;
                .thumbnail-blank-space {
                  .thumbnail-item {
                    display: inline-block;
                    width: 80px;
                    height: 80px;
                    background: #f4f4f4;
                    &:nth-child(n+2) {
                      margin-left: 16px;
                    }
                  }
                }
                // 隐藏滚动条
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none; /* IE 和 Edge */
                // 隐藏滚动条
                &::-webkit-scrollbar {
                    display: none; /* Chrome, Safari, Opera */
                }
              }
            }
          }
        }
        .detailsBox {
          margin-top: 44px;
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            margin-bottom: 10px;
          }
          .details {
            width: 100%;
            /deep/ .note-text {
              a {
                color: #2d8cf0 !important;
              }
              .wscnph {
                width: 100%;
              }
            }
            .price-text {
              margin: 10px 0;
              color: #333333;
              font-weight: 500;
              font-size: 14px;
            }
            p {
              font-family: PingFang TC, PingFang TC;
              font-weight: 400;
              font-size: 16px;
            }
          }
        }
      }
      .main_left::-webkit-scrollbar {
        display: none;
      }
      .main_right {
        flex: 1;
        height: calc(100vh - 80px - 124px);
        // overflow-y: auto;
        /* 隐藏滚动条 */
        // scrollbar-width: none; /* Firefox */
        // -ms-overflow-style: none; /* IE and Edge */
        .title {
          width: 100%;
          padding-right: 40px;
          box-sizing: border-box;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          line-height: 34px;
        }
        .tags {
          margin: 5px 0 15px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
        .Info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .price-box {
            font-family: PingFang TC-Medium;
            .price-balance {
              .balance-retailing {
                font-weight: 500;
                color: #333333;
                font-size: 18px;
              }
              .balance-original {
                margin-left: 7px;
                color: #999999;
                font-size: 12px;
                text-decoration: line-through;
              }
            }
            .price-pick {
              .pick-retailing {
                font-weight: 500;
                color: #333333;
                font-size: 18px;
              }
              .pick-original {
                margin-left: 7px;
                color: #999999;
                font-size: 12px;
                text-decoration: line-through;
              }
            }
          }
          .inventory {
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            span {
              margin-right: 10px;
            }
          }
        }
        .addressInfo{
          margin-top: 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          /deep/.el-icon-arrow-right{
            cursor: pointer;
          }
          .dropdown-arrow {
            transition: transform 0.3s ease;
            display: inline-block;
          }
          .dropdown-arrow.is-reverse {
            transform: rotate(180deg);
          }
          .btwInfo{
            display: flex;
            align-items: center;
            .param-info {
              display: flex;
              align-items: center;
            }
            span {
              margin-left: 20px;
              .param-names-text {
                display: inline-block;
                max-width: 200px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                margin-left: 2px;
              }
            }
            .addAddress {
              width: 72px;
              height: 22px;
              background: #F4F4F4;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              text-align: center;
              line-height: 22px;
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
        .skus {
          margin-top: 14px;
          .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
          .skuItem-scroll {
            height: 280px;
            overflow-y: auto;
            overflow-x: hidden;
            /* 隐藏滚动条 */
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE and Edge */
            .skuItem {
              display: flex;
              flex-wrap: wrap;
              gap: 14px 12px;
              .item {
                width: 274px;
                height: 50px;
                background: rgba(217,217,217,0);
                border-radius: 9px 9px 9px 9px;
                border: 1px solid #F4F4F4;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                text-align: center;
                line-height: 50px;
                cursor: pointer;
                user-select: none;
              }
              .active {
                border: 1px solid #EB6643;
                color: #EB6643;
              }
            }
          }
        }
        .skusNum {
          position: fixed;
          bottom: 20px;
          .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #999999;
            }
          }
          .btnNum {
            display: flex;
            gap: 31px;
            align-items: center;
            /deep/ .el-input-number {
              width: 120px;
            }
            /deep/ .el-input__inner {
              border: 0;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              height: 32px;
              line-height: 32px;
              padding-left: 30px;
              padding-right: 30px;
            }
            /deep/ .el-input-number__decrease {
              border-radius: 50%;
              border: 1px solid #DCDFE6;
              background: #fff;
              width: 32px;
              height: 32px;
              line-height: 32px;
            }
            /deep/ .el-input-number__increase {
              border-radius: 50%;
              border: 1px solid #DCDFE6;
              background: #fff;
              width: 32px;
              height: 32px;
              line-height: 32px;
            }
          }
          .btnBuy {
            width: 416px;
            height: 54px;
            background: linear-gradient( 270deg, #EE8C54 0%, #EA553C 100%);
            border-radius: 27px;
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            line-height: 54px;
            user-select: none;
            cursor: pointer;
          }
          .btnFinish {
            width: 416px;
            height: 54px;
            background: linear-gradient( 270deg, #EE8C54 0%, #EA553C 100%);
            border-radius: 27px;
            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            line-height: 54px;
            opacity: 0.5;
            user-select: none;
          }
        }
      }
      .main_right::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  padding: 0 !important;
  z-index: 999 !important;
  /* 服务说明样式 */
  .serve {
    padding: 10px 14px 22px 17px;
    min-width: 200px;
    h1 {
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin: 0 0 10px 0;
    }
    .item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 12px;
      .label {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          align-items: center;
          gap: 6px;
          .img {
            width: 14px;
            height: 14px;
          }
          .serve_text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }
        .rightImg {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }
      .value {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 1.5;
      }
    }
    .no-params {
      text-align: center;
      padding: 20px 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }
  /* 参数信息样式 */
  .parameter {
    padding: 10px 14px 22px 17px;
    h1 {
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin: 0 0 10px 0;
    }
    .param-list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      .item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 8px;
        max-width: 230px;
        .label {
          min-width: 80px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        .value {
          flex: 1;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }
      .no-params {
        text-align: center;
        padding: 20px 0;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>
